import api from '../api';

/**
 * Get manager access token
 * @param {string} apiKey - The API key
 * @returns {Promise<void>} The manager access token
 */
export const getManagerAccessToken = async (apiKey) => {
  await api.post('/login', { apiKey });
};

/**
 * Get manager logout
 * @returns {Promise<void>} The manager logout
 */
export const getManagerLogout = async () => {
  await api.post('/logout');
};
